{
  "es": {
    "document": {
      "actions": {
        "clear_selection": "Limpiar selección",
        "delete": "Eliminar",
        "deleteMultipleDocuments": "Eliminar",
        "delete_cancel": "Cancelar",
        "delete_documents": "Eliminar documento | Eliminar documentos",
        "delete_documents_upload": "Eliminar {count} documento | Eliminar {count} documentos",
        "download": "Descargar",
        "edit": "Editar",
        "edit_category": "Editar categoría",
        "groupByCategory": "Alternar agrupación por categoría",
        "hideDetails": "Ocultar detalles",
        "hide_for_project_partners": "Ocultar para colaboradores del proyecto",
        "new": "Documentos",
        "new_customer": "Añadir documentos",
        "reset_filters": "Restablecer filtros",
        "select_all": "Seleccionar los {total} documentos",
        "share": "Compartir",
        "shareCustomer": "Compartir con el cliente",
        "shareCustomerPartners": "Compartir con el cliente y los colaboradores del proyecto",
        "share_documents": "Compartir documento | Compartir documentos",
        "share_with": "Compartir con...",
        "share_with_project_partners": "Compartir con los colaboradores del proyecto",
        "showDetails": "Mostrar detalles",
        "submit": "Guardar",
        "tickBoxesDeletion": "Marca las casillas de los archivos que quieras eliminar.",
        "unshare": "Dejar de compartir",
        "unshare_documents": "Dejar de compartir documento | Dejar de compartir documentos"
      },
      "attachable_types": {
        "building": "Edificio",
        "decisions": "Decisiones",
        "installment": "Cuota",
        "issue": "Incidencia",
        "lot": "Parcela",
        "phase": "Fase",
        "project": "Proyecto",
        "tickets": "Conversaciones",
        "unit": "Unidad"
      },
      "attributes": {
        "category": "Categoría",
        "file_ext": "Tipo de archivo",
        "file_size": "Tamaño del archivo",
        "name": "Nombre",
        "size": "Tamaño",
        "type": "Tipo",
        "uploaded_at": "Subido el",
        "uploaded_by": "Subido por"
      },
      "category": {
        "admin": "Administración",
        "aftercare": "Posventa",
        "as_built": "Libro del Edificio",
        "brochure": "Folleto",
        "conversation": "Conversación",
        "decision": "Decisión",
        "image": "Imagen",
        "invoice": "Factura",
        "legal": "Legal",
        "manual": "Manual",
        "other": "Otro",
        "plan": "Plano",
        "quote": "Presupuesto",
        "ticket": "Conversación"
      },
      "labels": {
        "actions": "Acciones",
        "allDocuments": "Todos los documentos",
        "allUnits": "Todas las unidades",
        "backToCategories": "Categorías",
        "building": "edificio",
        "categories": "Categorías",
        "category": "Categoría",
        "changeCategory": "Cambiar categoría a:",
        "changeFilterOrStartUploading": "Cambia el filtro o sube un nuevo documento",
        "created": "Creado",
        "customer": "Cliente",
        "decision": "decisión",
        "decisionsAndProposals": "Decisiones y propuestas",
        "delete_documents": "¿Seguro que quieres eliminar este documento? Esta acción no se puede deshacer. | ¿Seguro que quieres eliminar estos documentos? Esta acción no se puede deshacer.",
        "disclaimerDocumentsCustomer": "Busca o sube documentos relacionados con la decisión {decision_name}",
        "documents": "Documentos",
        "documents_all": "Todos los documentos",
        "documents_all_projects": "Documentos de todos los proyectos",
        "documents_plan": "Documentos de planos",
        "documents_plan_explainer": "Los documentos añadidos a la carpeta de documentos de {unit_name} con la categoría «Plano» se añaden automáticamente a esta decisión y son accesibles para todos los colaboradores. ",
        "editDocument": "Editar documento",
        "editDocumentName": "Editar nombre del documento",
        "editDocumentNameSubtitle": "Introduce un nuevo nombre para el documento.",
        "fileTooLargeForPreview": "El archivo es demasiado grande para previsualizarlo. Prueba a descargarlo.",
        "files": "Archivos {level_name}",
        "files_count": "Sin archivos | 1 archivo | {count} archivos",
        "filter": "Filtro",
        "folders": "Carpetas",
        "goToUnitDocumentsFolder": "Ir a la carpeta de documentos de {unit_name}",
        "goToUnitsFolder": "Esta página solo contiene documentos de la decisión. Ve a la carpeta de la unidad para ver los demás documentos.",
        "include_original_documents": "Mostrar los documentos por firmar",
        "includesProposalAndDocuments": "Incluye documentos de la propuesta y documentos de la decisión",
        "info": "Aquí encontrarás pronto los documentos relacionados con tu vivienda.",
        "lockedDocumentApprovedProposal": "Este documento pertenece a una propuesta aprobada y no se puede eliminar",
        "lockedDocumentDelete": "Este documento no se puede eliminar",
        "lockedDocumentOtherLevel": "Este documento pertenece a {level} y solo se puede eliminar desde los documentos de {level}",
        "lockedDocumentShareLevel": "Este documento pertenece a {level} y no se puede compartir con los colaboradores del proyecto",
        "locked_parent_level": "Este documento se gestiona en un nivel superior y solo se puede editar o eliminar allí",
        "locked_template": "Este documento se creó a partir de una plantilla y no se puede editar ni eliminar",
        "lot": "parcela",
        "more_info": "Más información",
        "name_asc": "Nombre A-Z",
        "name_desc": "Nombre Z-A",
        "name_lower_asc": "Nombre A-Z",
        "name_lower_desc": "Nombre Z-A",
        "new": "Nuevo",
        "next": "Siguiente",
        "noCustomer": "Aún no hay cliente asignado",
        "noPreviewPossible": "No se puede previsualizar. Prueba a descargarlo primero.",
        "noResults": "Sin resultados",
        "no_plan_documents": "No se han añadido documentos de planos a la carpeta de la unidad",
        "onlyUnitDocumentsSharedWithProjectPartners": "Solo los documentos de la unidad se pueden compartir con los colaboradores del proyecto",
        "original_documents": "Documentos originales",
        "original_documents_info": "Muestra las versiones originales sin firmar de los documentos firmados o por firmar.",
        "owner": "Propietario",
        "page": "Página",
        "phase": "fase",
        "previous": "Anterior",
        "project": "proyecto",
        "project_partners": "Colaboradores del proyecto",
        "proposal": "propuesta",
        "searchName": "Buscar por nombre",
        "search_document": "Buscar documento",
        "selected": "{count} documento seleccionado | {count} documentos seleccionados",
        "selected_count": "{selected} documento seleccionado | {selected} documentos seleccionados",
        "shareWith": "Compartir con",
        "sharedWithClient": "Compartido con {client_name}",
        "sharedWithProjectPartners": "Compartido con los colaboradores del proyecto",
        "shared_with": "Compartido con",
        "shared_with_partners": "Compartido con colaboradores",
        "sharingSettingsDecision": "Dentro de esta decisión",
        "sharingSettingsProject": "En este proyecto",
        "showDocumentsFor": "Mostrar documentos de",
        "showLevel": "Este es un documento de {level}",
        "signature": "Firma",
        "signed": "Firmado",
        "signedBy": "Firmado por",
        "source": "Origen",
        "subtitleSharingDocuments": "El documento seleccionado estará disponible para los colaboradores del proyecto | Los documentos seleccionados estarán disponibles para los colaboradores del proyecto",
        "subtitleUnsharingDocuments": "El documento seleccionado dejará de estar disponible para los colaboradores del proyecto | Los documentos seleccionados dejarán de estar disponibles para los colaboradores del proyecto",
        "ticket": "conversación",
        "total_selected": "Los {total} documentos seleccionados",
        "unit": "unidad",
        "unitFolder": "Ir a los documentos de la unidad",
        "updated_at_asc": "Más antiguo primero",
        "updated_at_desc": "Más reciente primero",
        "upload_failed": "Uno o más archivos no se han podido subir. Elimínalos o vuelve a intentarlo.",
        "uploadedBy": "Subido por",
        "visibleFor": "Compartido con",
        "warningNotShared": "¡Vaya! No has seleccionado a nadie. ¿Seguro? Haz clic de nuevo para confirmar."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Recibirás una notificación por correo cuando haya un nuevo documento disponible. Consúltalos y descárgalos aquí.",
            "title": "Aquí encontrarás todos tus documentos"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Al subir documentos se notificará automáticamente por correo a todos los clientes relacionados.",
            "title": "Sin documentos para {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Navega por la estructura del proyecto para ver los documentos de una unidad",
            "title": "Ve a una unidad para ver los documentos"
          },
          "new": {
            "subtitle": "Al subir documentos se notificará automáticamente por correo a todos los clientes relacionados.",
            "title": "Sin documentos para esta decisión"
          },
          "none": {
            "subtitle": "Aquí encontrarás los documentos de {unit}",
            "title": "Aún no hay documentos"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Documento eliminado correctamente | Documentos eliminados correctamente",
        "bulk_upload": "Documento subido correctamente | Documentos subidos correctamente",
        "update": "{count} documento actualizado correctamente | {count} documentos actualizados correctamente",
        "upload_success": "{count} documento subido correctamente | {count} documentos subidos correctamente"
      },
      "upload": {
        "activeUpload": "Subiendo {count} archivo | Subiendo {count} archivos",
        "clear": "Limpiar",
        "complete": "Subida completada",
        "navigationWarning": {
          "continue": "Salir de todas formas",
          "header": "Subida en curso",
          "message": "Hay archivos subiéndose. Si sales de esta página se cancelará la subida y no se creará ningún documento."
        },
        "uploadFailed": "Error al subir"
      },
      "validation": {
        "need_category": "Categoría obligatoria",
        "need_category_all": "Todos los documentos deben tener una categoría",
        "selectDocument": "Selecciona al menos 1 documento"
      }
    }
  }
}
